import React from 'react'
import Navbar from '../components/common/Navbar'
import AboutUsHero from '../components/aboutusPage/AboutUsHero'
import AboutUsOriginStory from '../components/aboutusPage/AboutUsOriginStory'
import AboutUsFounder from '../components/aboutusPage/AboutUsFounder'
import AboutUsWhatWeDo from '../components/aboutusPage/AboutUsWhatWeDo'
import AboutUsMissionVision from '../components/aboutusPage/AboutUsMissionVision'
import AboutUsWhyChooseUs from '../components/aboutusPage/AboutUsWhyChooseUs'
import AboutUsLookingAhead from '../components/aboutusPage/AboutUsLookingAhead'

const AboutUsPage = () => {
  return (
    <div className='aboutus_page'>
        <Navbar />
        <AboutUsHero/>
        <AboutUsOriginStory/>
        <AboutUsFounder/>
        <AboutUsWhatWeDo/>
        <AboutUsMissionVision/>
        <AboutUsWhyChooseUs/>
        <AboutUsLookingAhead/>
    </div>
  )
}

export default AboutUsPage